import * as React from 'react';
import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Dialog, DialogTitle, Divider } from '@mui/material'
import { IconButton, CircularProgress } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { checkValidity, guestLoginDemo, getBookingPublicSimpleById, guestLogin, getLivekitUrl, getTenantByDomain, getUserPermissions, uploadImage, deletePhoto, getNextBookingOccurrence, isParticipantBanned } from '../../store/authThunks.js'
///import { useControls } from '../AvatarsMap/ControlsContext.js';
import { useNavigate } from 'react-router-dom';
import { Upload, X } from 'lucide-react';
import config from "../../../../constants/config.json";
import { useDispatch, useSelector } from 'react-redux';

import { setTenant, setLivekitUrl, login, setInvitationAuthorization } from '../../store/authSlice.js'; // adapte le chemin
import socketFactory from '../../../../utils/socketFactory.js';
import { sendTest } from '../../../../store/socketSlice/socketSlice.js';
import { getSubDomain } from '../../../Auth/utils/AuthUtils.js';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { clearLocalStorage } from '../../../Auth/utils/AuthUtils.js';
import CameraCapture from '../../../../components/AvatarPhoto/CameraCapture.js';
import PhotoAdjuster from '../../../../components/AvatarPhoto/PhotoAdjuster.js';
const avatars = [
  '/Avatars/new/Avatar1.svg',
  '/Avatars/new/Avatar2.svg',
  '/Avatars/new/Avatar3.svg',
  '/Avatars/new/Avatar4.svg',
  '/Avatars/new/Avatar5.svg',
  '/Avatars/new/Avatar6.svg',
  '/Avatars/new/Avatar7.svg',
  '/Avatars/new/Avatar8.svg',
  '/Avatars/new/Avatar9.svg',
  '/Avatars/new/Avatar10.svg',
  '/Avatars/new/Avatar11.svg',
  '/Avatars/new/Avatar12.svg',
  '/Avatars/new/Avatar13.svg',
  '/Avatars/new/Avatar14.svg',
  '/Avatars/new/Avatar15.svg',

];

const DEV_SERVER_URL = config.DEV_SERVER_URL;
const defaultTheme = createTheme();

export default function LoginGuest() {
  const [error, setError] = useState();
  const [avatarImage, setAvatarImage] = useState();
  const [username, setUsername] = useState();
  const [timeLeft, setTimeLeft] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);


  const invitationAuthorization = useSelector(state => state.auth.invitationAuthorization);
  const { t } = useTranslation();
  const { code, mapId } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const demoToken = urlParams.get("d");
  const isDemo = Boolean(demoToken || mapId);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [countdownTarget, setCountdownTarget] = useState(null); // ms epoch
  const [phase, setPhase] = useState("before"); // "before" | "during" | "after"
  const [countdownLabel, setCountdownLabel] = useState(""); // Texte dynamique
  const [openCameraCaptureModal, setOpenCameraCaptureModal] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [openAdjustImageModal, setOpenAdjustImageModal] = useState(false);
  const handleOpenVideo = () => {
    setOpenCameraCaptureModal(true);
  }
  const handleCloseVideo = () => {
    setOpenCameraCaptureModal(false);
  }
  const handleCaptureImage = (image) => {
    setCapturedImage(image);
    setOpenCameraCaptureModal(false);
    setOpenAdjustImageModal(true);
  }
  const handleSaveAdjustImage = async (file, preview) => {
    if (!file) return;

    // Validate type
    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      setError(t("PLEASE_UPLOAD_IMAGES_ONLY"));
      return;
    }
    // IMPORTANT: upload THE FILE
    if (file.size > 5 * 1024 * 1024) {
      setError(t("TAILLE_MAXIMALE_FICHIER"));
      return;
    } try {
      setAvatarImage('');

      localStorage.setItem('avatarImage', '');
      const formData = new FormData();
      formData.append('photo', file);
      const response = await dispatch(uploadImage({
        body: formData
      }))
      if (!response.payload.success) {
        throw new Error('Upload failed');
      }
      setCustomPhoto(response.payload.photoUrl);
      setAvatarImage(response.payload.photoUrl);
      localStorage.setItem('avatarImage', response.payload.photoUrl);
      handleCloseAdjustImage();
    } catch (err) {
      setError(t("UPLOAD_PHOTO_ERROR"));
      console.error('Upload error:', err);
    } finally {
    }
  }
  const handleCloseAdjustImage = () => {
    setOpenAdjustImageModal(false);
    setCapturedImage(null);
  }

  const handleReturnToCapture = () => {
    setOpenAdjustImageModal(false);
    setOpenCameraCaptureModal(true);
    setCapturedImage(null);
  }
  const isConferenceUrl = window.location.href.includes('conference');

  useEffect(() => {
    let endTimeoutId;
    let nextCheckId;
    let hasFetchedNext = false;

    const handleNoNextOccurrence = () => {
      setPhase('after');
      setCountdownLabel('Aucune réunion planifiée');
      setIsButtonDisabled(true);
      setCountdownTarget(null);
      setTimeLeft(0);
    };

    const fetchNext = async (bookingId) => {
      try {
        const next = await dispatch(
          getNextBookingOccurrence({ params: [{ id: bookingId }] })
        ).unwrap();

        if (next?.date) {
          const nextStart = new Date(next.date).getTime();
          setPhase('after');
          setCountdownLabel('Prochaine réunion dans');
          setIsButtonDisabled(true);
          setCountdownTarget(nextStart);
          setTimeLeft(Math.ceil((nextStart - Date.now()) / 1000));
          return;
        }
        handleNoNextOccurrence();
        return;
      } catch (err) {
        console.error('Erreur récupération prochaine occurrence:', err);
        handleNoNextOccurrence();
      }
    };

    const planEnd = (remaining, bookingId) => {
      clearTimeout(endTimeoutId);
      endTimeoutId = setTimeout(async () => {
        await fetchNext(bookingId);
      }, remaining);
    };

    const init = async () => {
      try {
        clearLocalStorage();

        const urlParams = new URLSearchParams(window.location.search);

        const roomIdFromUrl = urlParams.get('room_id');
        const bookingIdFromUrl = urlParams.get('booking_id');

        const roomId =
          roomIdFromUrl || sessionStorage.getItem('autojoin_room_id');
        let bookingId =
          bookingIdFromUrl || sessionStorage.getItem('autojoin_booking_id');

        if (roomId) sessionStorage.setItem('room_id', roomId);
        if (bookingId) sessionStorage.setItem('booking_id', bookingId);

        if (!bookingId) {
          setIsButtonDisabled(false);
          return;
        }
        const bookingData = await dispatch(
          getBookingPublicSimpleById({ params: [{ bookingId }], options: { headers: { 'x-guest-code': code } } })
        ).unwrap();
        const type = bookingData.type;
        const is_conference_active = bookingData.is_active;
        const startTime = bookingData.date;
        console.log("guestBooking", bookingData)
        console.log("type", type)
        console.log("is-active", is_conference_active)


        const start = new Date(startTime).getTime();
        const now = Date.now();
        console.log("start", start)
        console.log("now", now)
        if (type === 'conference') {
          if (is_conference_active) {
            console.log("dkhalt 1 ")
            setPhase('during');
            setCountdownLabel('Conférence en cours');
            setIsButtonDisabled(false);
            setCountdownTarget(null);
          } else if (start > now) {
            console.log("dkhalt 2 ")
            const diffToStart = start - now;
            setPhase('before');
            setCountdownLabel('Début de la conférence dans');
            setIsButtonDisabled(true);
            setCountdownTarget(start);
            setTimeLeft(Math.ceil(diffToStart / 1000));
          } else {
            console.log("testttttttt")
            setPhase('after');
            setCountdownLabel('Conférence terminée');
            setIsButtonDisabled(true);
            setCountdownTarget(null);
          }
          return;
        }




        const durMin = bookingData.duration || 15;
        const end = start + durMin * 60 * 1000;
        if (!bookingData?.date) {
          console.warn("Aucune réunion actuelle trouvée → recherche prochaine occurrence…");
          await fetchNext(bookingId);
          return;
        }

        if (now < start) {
          const diffToStart = start - now;
          setPhase('before');
          setCountdownLabel('Début dans');
          setIsButtonDisabled(true);
          setCountdownTarget(start);
          setTimeLeft(Math.ceil(diffToStart / 1000));

          nextCheckId = setTimeout(() => {
            setPhase('during');
            setCountdownLabel('Temps restant');
            setIsButtonDisabled(false);
            setCountdownTarget(end);
            planEnd(end - Date.now(), bookingId);
          }, diffToStart);

          return;
        }

        if (now >= start && now < end) {
          setPhase('during');
          setCountdownLabel('Temps restant');
          const remaining = end - now;
          setIsButtonDisabled(false);
          setCountdownTarget(end);
          planEnd(remaining, bookingId);
          console.log(
            'Réunion en cours. Fin dans',
            Math.round(remaining / 1000),
            'sec'
          );
          return;
        }

        if (now >= end && !hasFetchedNext) {
          hasFetchedNext = true;
          await fetchNext(bookingId);
        }
      } catch (e) {
        console.error('Erreur init booking:', e);
        setError('Impossible de récupérer les informations de la réunion.');
        setIsButtonDisabled(false);
      }
    };

    init();

    return () => {
      clearTimeout(endTimeoutId);
      clearTimeout(nextCheckId);
    };
  }, []);


  useEffect(() => {
    if (!countdownTarget) return;

    const tick = () => {
      const now = Date.now();
      const secs = Math.max(0, Math.ceil((countdownTarget - now) / 1000));
      setTimeLeft(secs);
      if (secs <= 0) {
        if (phase === 'after') {
          setIsButtonDisabled(true);
        } else {
          setIsButtonDisabled(false);
        }

        setCountdownTarget(null);
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [countdownTarget, phase]);




  const handleDemoLogin = async () => {
    try {
      const subDomain = getSubDomain();

      const tenantResp = await dispatch(
        getTenantByDomain({ params: [{ subDomain }] })
      ).unwrap();

      const fallbackTenantId = tenantResp?.tenant?.id;
      if (!fallbackTenantId) {
        setError("Tenant introuvable");
        return;
      }

      const demoPayload = {
        username,
        url_photo: avatarImage,
        ...(demoToken
          ? { demoToken }
          : { map_id: mapId, tenant_id: fallbackTenantId }),
      };

      const loginResp = await dispatch(
        guestLoginDemo({ body: demoPayload })
      ).unwrap();

      if (loginResp?.tokenResponse?.access_token && loginResp?.email) {
        const tenantId =
          loginResp?.tenant?.id || loginResp?.tenantId || fallbackTenantId;

        await dispatch(getLivekitUrl({ params: [{ tenantId }] }));

        localStorage.setItem("isLogin", "true");
        localStorage.setItem("token", loginResp.tokenResponse.access_token);
        localStorage.setItem("refresh_token", loginResp.tokenResponse.refresh_token);
        localStorage.setItem("name", username);
        localStorage.setItem("email", loginResp.email);
       

        if (demoToken) localStorage.setItem("demoToken", demoToken);
        if (mapId) localStorage.setItem("demoMapId", mapId);

        await dispatch(getUserPermissions());
        navigate("/", { replace: true });
      } else {
        setError("Erreur lors de la connexion demo.");
      }
    } catch (error) {
      console.error("Erreur DEMO login:", error);
      setError("Erreur lors du login demo.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError();

    if (!username && !avatarImage) {
      setError(t("Please-choose-an-avatar-and-enter-a-pseudo"));
      return;
    }
    if (!username) {
      setError(t("Please-enter-a-pseudo"));
      return;
    }
    if (!avatarImage) {
      setError(t("Please-choose-an-avatar"));
      return;
    }

    try {
      const roomId = sessionStorage.getItem("room_id");

      if (isDemo) {
        return handleDemoLogin();
      }


      const result = await dispatch(checkValidity({ params: [{ code }] })).unwrap();

      if (result === "Guest token is valid.") {
        const login = await dispatch(
          guestLogin({ body: { code, username, url_photo: avatarImage } })
        ).unwrap();

        if (login === "max_guest_reached") {
          dispatch(setInvitationAuthorization(false));
          return;
        }
        await dispatch(getLivekitUrl({ params: [{ tenantId: login.tenant.id }] }));
        localStorage.setItem("isLogin", true);
        localStorage.setItem("token", login.tokenResponse.access_token);
        localStorage.setItem("refresh_token", login.tokenResponse.refresh_token);
        localStorage.setItem("name", username);
        localStorage.setItem("email", login.email);
        localStorage.setItem("code", code);

        if (roomId) {
          navigate("/", { replace: true });
        } else {
          navigate("/", { replace: true });
        }
        await dispatch(getUserPermissions());
      } else {
        setError(t("your link is not valid"));
      }
    } catch (error) {
      console.error("An error occurred during submission:", error);
      setError("Erreur lors de la connexion de l'invité.");
    }
  };

  const handleSubmitIsfromInscription = async (event) => {
    event.preventDefault();
    setError();

    try {
      const bookingId = sessionStorage.getItem('booking_id');
      if (bookingId) {
        const bookingData = await dispatch(
          getBookingPublicSimpleById({ params: [{ bookingId }], options: { headers: { 'x-guest-code': code } } })
        ).unwrap();
        const startTime = bookingData.date;
        const type = bookingData.type;
        const is_conference_active = bookingData.is_active;
        const start = new Date(startTime).getTime();
        const now = Date.now();


        console.log("guestBooking", bookingData)
        console.log("type", type)
        console.log("is-active", is_conference_active)
        if (type === 'conference' && !is_conference_active && start < now) {
          setPhase('after');
          setCountdownLabel('Conférence terminée');
          setIsButtonDisabled(true);
          setCountdownTarget(null);

          setError("La session s'est terminée entre-temps.");
          return;
        }
      }
      if (bookingId && code) {
        console.log("Vérification du bannissement pour :", bookingId, code);
        const conferenceId = bookingId;
        const isBanned = await dispatch(
          isParticipantBanned({ body: { code, conferenceId } })
        ).unwrap();
        console.log("isBanned", isBanned.isBanned)
        if (isBanned.isBanned) {
          setError("Accès refusé : Vous avez été banni de cette conférence.");
          return;
        }
      }

      const result = await dispatch(checkValidity({ params: [{ code }] })).unwrap();

      if (result === "Guest token is valid.") {
        const login = await dispatch(
          guestLogin({ body: { code } })
        ).unwrap();

        if (login === "max_guest_reached") {
          dispatch(setInvitationAuthorization(false));
          return;
        }
        await dispatch(getLivekitUrl({ params: [{ tenantId: login.tenant.id }] }));
        localStorage.setItem("isLogin", true);
        localStorage.setItem("token", login.tokenResponse.access_token);
        localStorage.setItem("refresh_token", login.tokenResponse.refresh_token);
        localStorage.setItem("email", login.email);
        localStorage.setItem("isConferenceGuest", true);
        localStorage.setItem("code", code);

        await dispatch(getUserPermissions());

        navigate("/", { replace: true });
      } else {
        setError(t("your link is not valid"));
      }
    } catch (error) {
      console.error("An error occurred during submission:", error);
      setError("Erreur lors de la connexion de l'invité.");
    }
  };

  const avatarClickHandler = (avatar) => {
    setAvatarImage(avatar);
    localStorage.setItem('avatarImage', avatar);

  };
  const [open, setOpen] = React.useState(true);



  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setError();
      return;
    }
    setError();
    setOpen(false);
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setError(null);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [error]);
  const [customPhoto, setCustomPhoto] = useState(null);


  const handlePhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setError(t("PLEASE_UPLOAD_IMAGES_ONLY"));
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setError(t("TAILLE_MAXIMALE_FICHIER"));
        return;
      }

      try {
        setAvatarImage('');

        localStorage.setItem('avatarImage', '');

        const reader = new FileReader();
        reader.onload = (e) => {
          setCustomPhoto(e.target.result);
        };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append('photo', file);

        const response = await dispatch(uploadImage({
          body: formData
        }))

        if (!response.payload.success) {
          throw new Error('Upload failed');
        }
        setAvatarImage(response.payload.photoUrl);
        localStorage.setItem('avatarImage', response.payload.photoUrl);

      } catch (err) {
        setError(t("UPLOAD_PHOTO_ERROR"));
        console.error('Upload error:', err);
      } finally {
      }
    }
  };


  const removeCustomPhoto = async () => {
    if (avatarImage) {
      try {
        dispatch(
          deletePhoto({ body: { url_photo: avatarImage } })
        )


        /* if (!response.ok) {
           throw new Error('Delete failed');
         }*/
      } catch (err) {
        console.error('Error deleting photo:', err);
      }
    }

    setCustomPhoto(null);
    setAvatarImage('');
    localStorage.setItem('avatarImage', '');
  };
  const formatCountdown = (totalSeconds) => {
    if (totalSeconds <= 0) return "0s";

    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days > 0) parts.push(`${days}j`);
    if (hours > 0 || days > 0) parts.push(`${String(hours).padStart(2, "0")}h`);
    if (minutes > 0 || hours > 0 || days > 0) parts.push(`${String(minutes).padStart(2, "0")}m`);
    parts.push(`${String(seconds).padStart(2, "0")}s`);

    return parts.join(" ");
  };


  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Container width="100vh" sx={{ height: "100vh", overflowY: 'auto' }}>
        <Container component="main" maxWidth="sm">
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >

            <img
              src='/LoginAifel.svg'
              style={{
                maxWidth: '300px',
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginTop: '10px'
              }}
              alt="Login Logo"
            />
            {isConferenceUrl ? (
              <Box component="form" onSubmit={handleSubmitIsfromInscription} noValidate sx={{ mt: 1 }} style={{ width: '457px' }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={isButtonDisabled}
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: isButtonDisabled ? '#7a7979ff' : '#77dd48',
                    color: '#0C0C0C',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    '&:hover': {
                      backgroundColor: isButtonDisabled ? '#7a7979ff' : 'var(--peoplmap-primary)'
                    },
                  }}
                >
                  {/* 1. Compteur actif UNIQUEMENT en phase "before" (attente du début) */}
                  {phase === "before" && countdownTarget && timeLeft > 0
                    ? `${countdownLabel} : ${formatCountdown(timeLeft)}`
                    :
                    phase === "during"
                      ? t("REJOINDRE")
                      :
                      phase === "after"
                        ? t("REUNION_TERMINEE")
                        :
                        t("REJOINDRE")}
                </Button>



              </Box>
            ) : (
              <>
                {invitationAuthorization ? (
                  <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }} style={{ width: '457px' }}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="username"
                      label="Prénom (nom)"
                      name="username"
                      autoComplete="username"
                      autoFocus
                      variant="standard"
                      inputProps={{ maxLength: 20 }}
                      onChange={(e) => setUsername(e.target.value)}
                      sx={{
                        '& .MuiInput-underline:before': {
                          borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                          borderRadius: '0 !important',
                        },
                        '& .MuiInput-input': {
                          borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                          borderRadius: '0 !important',
                        },
                        '& .MuiInput-underline:after': {
                          borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                          borderRadius: '0 !important',
                        },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                          borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused': {
                          '& fieldset': {
                            borderColor: 'rgba(0, 0, 0, 0.6)',
                          },
                        },
                        '& .MuiFormLabel-asterisk': {
                          color: '#F26969',
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          '&.Mui-focused': {
                            color: 'rgba(0, 0, 0, 0.6)',
                          },
                        },
                      }}
                    />


                    <div className='custom-avatar-photo-wrapper'
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flexDirection: 'row'
                      }} >
                      {/* photo from camera*/}
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                        <Button
                          variant="outlined"
                          onClick={handleOpenVideo}
                          sx={{
                            borderColor: '#60D744',
                            color: '#60D744',
                            gap: '10px',
                            padding: '12px 22px 12px 18px',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'row',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontFamily: 'Poppins',
                            fontWeight: '500',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                            letterSpacing: 'normal',
                            textTransform: 'math-auto',
                            '&:hover': {
                              borderColor: 'var(--F)',
                              backgroundColor: 'rgba(119, 221, 72, 0.04)'
                            }
                          }}
                        >
                          <span className="material-symbols-outlined">
                            photo_camera
                          </span>
                          Prendre une photo
                        </Button>
                      </Box>
                      {/* Photo upload button */}
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                        <input
                          type="file"
                          accept="image/*"
                          id="photo-upload"
                          style={{ display: 'none' }}
                          onChange={handlePhotoUpload}
                        />
                        <label htmlFor="photo-upload">
                          <Button
                            component="span"
                            variant="outlined"
                            sx={{
                              borderColor: '#60D744',
                              color: '#60D744',
                              gap: '10px',
                              padding: '12px 22px 12px 18px',
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection: 'row',
                              borderRadius: '8px',
                              fontSize: '14px',
                              fontFamily: 'Poppins',
                              fontWeight: '500',
                              fontStyle: 'normal',
                              lineHeight: 'normal',
                              letterSpacing: 'normal',
                              textTransform: 'math-auto',
                              '&:hover': {
                                borderColor: 'var(--F)',
                                backgroundColor: 'rgba(119, 221, 72, 0.04)'
                              }
                            }}
                          >
                            <span class="material-symbols-outlined">
                              add_photo_alternate
                            </span>
                            Importer votre photo
                          </Button>
                        </label>
                      </Box>
                    </div>
                    <Dialog open={openCameraCaptureModal} onClose={handleCloseVideo} maxWidth="md" PaperProps={{
                      component: "form",
                      className: `paper lg`,
                    }} fullWidth>
                      <DialogTitle sx={{ padding: "3px 18px", fontSize: "1 rem" }}>
                        <div className="title-dialog">
                          <h2>
                            {t("take_photo")}
                          </h2>
                          <span className="material-symbols-outlined cursor-pointer" onClick={handleCloseVideo}>
                            close
                          </span>
                        </div>

                        <Divider
                          sx={{
                            marginTop: "2px",
                            marginBottom: "13px",
                            backgroundColor: "#CDD5DF"
                          }}
                        />
                      </DialogTitle>
                      <CameraCapture
                        onCapture={handleCaptureImage}
                        onClose={handleCloseVideo}
                      />
                    </Dialog>
                    <Dialog open={openAdjustImageModal} onClose={handleCloseAdjustImage} maxWidth="md" PaperProps={{
                      component: "form",
                      className: `paper lg`,
                    }} fullWidth>
                      <DialogTitle sx={{ padding: "3px 18px", fontSize: "1 rem" }}>
                        <div className="title-dialog">
                          <h2>
                            {t("adjust_photo")}
                          </h2>
                          <span className="material-symbols-outlined cursor-pointer" onClick={handleCloseAdjustImage}>
                            close
                          </span>
                        </div>

                        <Divider
                          sx={{
                            marginTop: "2px",
                            marginBottom: "13px",
                            backgroundColor: "#CDD5DF"
                          }}
                        />
                      </DialogTitle>
                      <PhotoAdjuster
                        image={capturedImage}
                        onSave={handleSaveAdjustImage}
                        onReturn={handleReturnToCapture}
                      />
                    </Dialog>


                    {/* Custom photo preview */}
                    {customPhoto && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, position: 'relative' }}>
                        <Avatar
                          src={customPhoto}
                          variant="rounded"
                          sx={{
                            width: 64,
                            height: 64,
                            border: '4px solid #77dd48'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={removeCustomPhoto}
                          sx={{
                            position: 'absolute',
                            top: -8,
                            right: '50%',
                            transform: 'translateX(32px)',
                            backgroundColor: '#77dd48',
                            color: 'white',
                            '&:hover': {
                              backgroundColor: 'var(--peoplmap-primary)'
                            }
                          }}
                        >
                          <X size={16} />
                        </IconButton>
                      </Box>
                    )}
                    <Typography component="h6" variant="h6" sx={{ mt: 2 }}>
                      Ou choisissez votre avatar
                    </Typography>
                    {/* Existing avatars grid */}
                    <Grid container spacing={2} justifyContent="center" mt={1}>
                      {avatars.map((avatar, index) => (
                        <Grid item key={index} xs={6} sm={4} md={3} lg={2.4}>
                          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Avatar
                              src={avatar}
                              variant="rounded"
                              onClick={!customPhoto ? () => avatarClickHandler(avatar) : undefined}
                              sx={{
                                cursor: customPhoto ? 'auto' : 'pointer',
                                border: avatarImage === avatar ? '4px solid #77dd48' : 'none',
                                borderRadius: '20px',
                                width: 56,
                                height: 56
                              }}
                            />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      disabled={isButtonDisabled}
                      sx={{
                        mt: 3,
                        mb: 2,
                        backgroundColor: isButtonDisabled ? '#7a7979ff' : '#77dd48',
                        color: '#0C0C0C',
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontStyle: 'normal',
                        lineHeight: 'normal',
                        letterSpacing: 'normal',
                        textTransform: 'math-auto',
                        '&:hover': {
                          backgroundColor: isButtonDisabled ? '#7a7979ff' : 'var(--peoplmap-primary)'
                        },
                      }}
                    >
                      {countdownTarget && countdownLabel
                        ? `${countdownLabel} : ${formatCountdown(timeLeft)}`
                        : phase === "during"
                          ? `Réunion en cours (${formatCountdown(timeLeft)})`
                          : phase === "after"
                            ? "Aucune réunion planifiée"
                            : "Rejoindre"}

                    </Button>



                  </Box>
                ) : (


                  <div className='msg-cnx'>
                    <h2>
                      {t("MAX_GUESTS_REACHED")}
                    </h2>
                    <h2>
                      {t("PLEASE_TRY_AGAIN_LATER")}
                    </h2>

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => dispatch(setInvitationAuthorization(true))}
                      sx={{
                        mt: 3,
                        mb: 2,
                        backgroundColor: '#77dd48',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: isButtonDisabled ? '#77dd48' : 'var(--peoplmap-primary)'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: '#77dd48',
                          color: 'white',
                        }
                      }}
                    >
                      {t("TRY_AGAIN")}
                    </Button>
                  </div>
                )}
              </>
            )}
          </Box>
        </Container>
      </Container>
    </ThemeProvider>
  );
}
